
import { Button, Modal } from "react-bootstrap";
import "./create-std-assessment-ai.modal.scss";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Question, QuestionLanguage } from "../model/questions-summary.model";
import { v4 as uuidv4 } from 'uuid';
import { genQuestionByCompanyUrl } from "../services/api.service";
import LOADING_JSON from "../assets/json/loading.json"
import Lottie from "lottie-react";
import AI_PURPLE from "../assets/images/ai-icon-purple.png";
import AI_WHITE from "../assets/images/ai-icon.png";
import config from "../config";
import { ProviderContext } from "../contexts/provider.context";
import tokenService from "../services/token.service";
interface CreateSTdAssAIModalProps {
    isOpen: boolean
    onClose(): void
    totalQuestion: Question[];
    onAddQuestion(any, string, number): void

}
const CreateStdAssessmentAIModal: React.FC<CreateSTdAssAIModalProps> = ({ isOpen, onClose, onAddQuestion, totalQuestion }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {profileModel} :any = useContext(ProviderContext);
    const [questionList, setQuestionList] = useState<Question[]>([]);
    const [formList, setFormList] = useState([
        { label: "กรอก URL ของเว็บไซต์บริษัทของคุณ", field: "url", value: "", is_error: true, error_message: "กรุณากรอก url" },
        { label: "จำนวนข้อคำถาม", field: "amount", value: "", is_error: true, error_message: "กรุณาเลือก จำนวนข้อ" },

    ])



    const clickToGenerateQuestion = () => {
        setIsSubmitting(true);
        if (formList[0].value && formList[1].value) {
            setIsLoading(true);
            genQuestionByCompanyUrl(formList[0].value, formList[1].value).then((res) => {

                if (res.data.is_success) {
                    setIsLoading(false);
                    console.log(res.data);
                    const result = res.data.message.questions as Question[];
                    result.map((item,index) => {
                        result[index].topic = "standard_questions";
                        result[index].created_by = tokenService.getProfile().email
                    })
                    setQuestionList(result);
                    // totalQuestion.push(...result);
                    onAddQuestion(result, formList[0].value, formList[1].value);

                }
            })
        }
    }
    const handleInputChange = (event: any, field: string, index) => {
        const value = event.target.value;
        if (formList) {
            const formListMod = [...formList];
            formListMod[index].value = value;
            formListMod[index].is_error = false;
            formListMod[index].error_message = "";
            setFormList(formListMod);
        }

    };
    return (
        <Modal show={isOpen} onHide={onClose} centered backdrop="static" >
            <Modal.Body className="create-std-asm-ai-modal">
                <FontAwesomeIcon icon={faClose} className="create-std-close-icon" onClick={onClose}></FontAwesomeIcon>
                {
                    isLoading ?
                        <>
                            <div className="create-std-asm-ai-loading-control">
                                <Lottie animationData={LOADING_JSON} className="icon" ></Lottie>
                                <span className="text">กำลังสร้างคำถาม ...</span>
                            </div>
                        </> :
                        <>
                            <div className="create-std-asm-ai-title-control">
                                <img src={AI_PURPLE} className="icon"></img>
                                <span className="create-std-asm-ai-title">สร้างคำถามพิ้นฐานขององค์กรด้วย AI</span>
                            </div>
                            <span className="create-std-asm-ai-sub-title">กรุณาระบุ URL เว็บไซต์บริษัทของคุณ เพื่อให้ AI ใช้ข้อมูลในการสร้างคำถามพื้นฐานขององค์กร</span>

                            <div className="create-std-form-control">
                                <div className="create-std-company-control">
                                    {formList.map((item, index) => {
                                        // Skip fields at index 6 and 7

                                        const hasError = isSubmitting && item.is_error;
                                        return (
                                            index == 0 ?
                                                <FormControl
                                                    key={index}
                                                    className={`input-std${hasError ? " input-error" : ""}`}
                                                    fullWidth
                                                >
                                                    <TextField
                                                        id={`input-${index}`}
                                                        label={item.label}
                                                        variant="outlined"
                                                        value={item.value}
                                                        onChange={(e) => handleInputChange(e, item.field, index)}
                                                    />
                                                </FormControl> :
                                                <FormControl
                                                    key={index}
                                                    className={`input-std${hasError ? " input-error" : ""}`}
                                                    fullWidth
                                                >
                                                    <InputLabel id="demo-simple-select-label">{item.label}</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label-2"
                                                        id="demo-simple-select-2"
                                                        value={item.value}
                                                        variant="outlined"
                                                        label="เวลาในการสัมภาษณ์"
                                                        className="job-position-item-input-field"
                                                        onChange={(e) => handleInputChange(e, item.field, index)}
                                                    >
                                                        {Array.from({ length: config.questions.std_questions - totalQuestion.length }, (_, index) => (
                                                            <MenuItem value={index + 1} key={index}>
                                                                {index + 1} ข้อ
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                        );
                                    })}

                                    <div className="create-std-ai-add-button-control">
                                        <Button className="create-std-button-cancel" onClick={onClose}>ยกเลิก</Button>
                                        <Button className="button-std create-std-button-submit"
                                            onClick={clickToGenerateQuestion}>
                                            <img src={AI_WHITE} className="icon"></img>สร้างคำถามด้วย AI</Button>
                                    </div>


                                </div>
                            </div>
                        </>
                }



            </Modal.Body>

        </Modal>
    )


}

export default CreateStdAssessmentAIModal;